import React from 'react';

export const
  lorem = () => <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Ut malesuada ex arcu, eu aliquet sapien imperdiet ac.
    Aliquam turpis nulla, molestie id sem ut, porttitor pellentesque tellus.
    In urna augue, rutrum quis vestibulum quis, tincidunt a turpis.
    Cras sollicitudin augue orci, nec sollicitudin massa porttitor vitae.
    Donec a lobortis felis.</p>,

    jQuery = window.jQuery,
    Component = window.wp.element.Component,
    Fragment = window.wp.element.Fragment,

    demographics = [
       { key: 'white', name: 'White' },
       { key: 'hispanic', name: 'Hispanic' },
       { key: 'black', name: 'Black' },
       { key: 'asian', name: 'Asian' },
    ],
    ranges = {
	  "hs-graduate" :[0,100],
	  "bachelors" : [0,100],
	  "household-income" :  [0, 110000],
	  "poverty-rate": [0,50],
	  "median-wealth": [0,220000],
	  "homeownership": [0,100],
	  "marriage-rate": [0,100],
	  "life-expectancy": [50,90]
    },

    indicators = [ [
       { key: 'hs-graduate', name: 'High school completion' },
       { key: 'bachelors', name: "Bachelor's degree+" },
    ], [
       { key: 'household-income', name: 'Household income'},
       { key: 'poverty-rate', name: 'Poverty rate'},
       { key: 'median-wealth', name: 'Median wealth'},
       { key: 'homeownership', name: 'Homeownership'},
    ], [
       { key: 'marriage-rate', name: 'Marriage rate'},
       { key: 'life-expectancy', name: 'Life expectancy'}
    ]
  ],
  years = {
    "hs-graduate" : 1962,
    "bachelors": 1962,
    "marriage-rate": 1962,
    "household-income": 1962,
    "poverty-rate" : 1962,
    "median-wealth" : [
      1983,
      1989,
      1992,
      1995,
      1998,
      2001,
      2004,
      2007,
      2010,
      2013,
      2016,
      2019
    ],
    "homeownership" : 1976,
    "voter-turnout" : [
      1980,
      1984,
      1988,
      1992,
      1996,
      2000,
      2004,
      2008,
      2012,
      2016
    ],
    "life-expectancy" : [
    1970,
	1975,
	1980,
	1981,
	1982,
	1983,
	1984,
	1985,
	1986,
	1987,
	1988,
	1989,
	1990,
	1991,
	1992,
	1993,
	1994,
	1995,
	1996,
	1997,
	1998,
	1999,
	2000,
	2001,
	2002,
	2003,
	2004,
	2005,
	2006,
	2007,
	2008,
	2009,
	2010,
	2011,
	2012,
	2013,
	2014,
	2015,
	2016
    ]
     },
  titles = {
	"hs-graduate" : ['High school completion', '% of adults ages 25 and older with a high school diploma or more education'],
	"bachelors" : [ 'Bachelor’s degree completion', '% of adults ages 25 and older with a bachelor’s degree or more education'],
	"household-income" : ['Household income', 'Median household income adjusted for household size and scaled to reflect a three-person household, in 2019 dollars'],
	"poverty-rate" : ['Poverty rate', '% of population living in poverty'],
	"median-wealth" : ['Median wealth', 'Median wealth of families, in 2019 dollars'],
	"homeownership" : ['Homeownership', '% of households owning a home'],
	"marriage-rate" : ['Marriage rate', ' % of adults ages 18 and older who are married'],
	"life-expectancy" : ['Life expectancy', 'Life expectancy at birth in years']
  },
  captions = {
    "hs-graduate" : `<p><strong>What the data show:</strong> High school completion rates in the U.S. have been on the rise for decades. For the first time in 2020, White, Black and Asian adults all have graduation rates equal to or higher than 90%. Meanwhile, Hispanic adults trail behind at 74%. High school completion rates have quadrupled among Black adults over the past 60 years.</p>`,
    "bachelors": `<p><strong>What the data show:</strong> College completion rates among U.S. adults have been on the rise for all racial and ethnic groups, but gaps remain. As of 2020, 62% of Asian adults have completed a bachelor’s degree, which is significantly higher than any other racial or ethnic group. Black and Hispanic adults are the least likely to have a bachelor’s degree.</p>`,
    "marriage-rate": `<p><strong>What the data show:</strong> Marriage rates among U.S. adults have declined since the 1960s. Black adults have seen the largest drop over time, followed by Hispanic adults and White adults. Marriage rates for Asian adults have been more stable since 1988, when data on this group was first collected.</p>`,
    "household-income": `<p><strong>What the data show:</strong> The median incomes of Black and Hispanic households continue to lag behind those of White households, while households headed by Asian adults have higher incomes than all other groups. These patterns have been consistent over time.</p>`,
    "poverty-rate" : `<p><strong>What the data show:</strong> Poverty rates have declined in recent years, but the share of people living in poverty varies by racial and ethnic group. Black and Hispanic Americans remain more likely than their White and Asian counterparts to be living in poverty.</p>`,
    "median-wealth" : `<p><strong>What the data show:</strong> U.S. households headed by people who are White have significantly higher levels of wealth than those headed by people who are Black or Hispanic. The racial wealth gap between White and Black households peaked in 2007, prior to the Great Recession, and has been on the rise again over the past decade.</p>`,
    "homeownership" : `<p><strong>What the data show:</strong> White U.S. households have higher rates of homeownership than any other racial or ethnic group, while Black and Hispanic households have the lowest rates. Asian homeownership rates peaked in 2020.</p>`,
    "life-expectancy" : `<p><strong>What the data show:</strong> Overall, life expectancy has increased for all U.S. groups over time. As of 2015, Hispanic adults have the longest life expectancy (82 years), followed by White adults (79 years) and Black adults (76 years). The gap between White and Black adults has narrowed in recent decades.</p>`
  },
  notes = {
	  "hs-graduate" : `<p>Note: “High school” includes those who have a high school diploma or its equivalent, such as a General Education Development (GED) certificate. White, Black and Asian adults include those who report being only one race and are not Hispanic. Hispanics are of any race. Prior to 1974, White and Black adults include the Hispanic portion of those groups. Asian adults include Pacific Islanders before 2003. Data on Hispanic adults not available prior to 1974. Data on Asian adults not available before 1988. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1962 to 2020 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p>`,
	"bachelors" : `<p>Note: White, Black and Asian adults include those who report being only one race and are not Hispanic. Hispanics are of any race. Prior to 1974, White and Black adults include the Hispanic portion of those groups. Asian adults include Pacific Islanders before 2003. Data on Hispanic adults not available prior to 1974. Data on Asian adults not available before 1988. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1962 to 2020 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p>`,
	"marriage-rate" : `<p>Note: White, Black and Asian adults include those who report being only one race and are not Hispanic. Hispanics are of any race. Prior to 1974, White and Black adults include the Hispanic portion of those groups. Asian adults include Pacific Islanders before 2003. Data on Hispanic adults not available prior to 1974. Data on Asian adults not available before 1988. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1962 to 2020 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p>`,
	"household-income" : `<p>Note: Results are based on income sources in the calendar year prior to the survey, so the impact of the COVID-19 pandemic will not be reflected in the data. Revisions to the Current Population Survey affect the comparison of data from 2015 onwards. White, Black, Hispanic, and Asian households refer to the race or ethnicity of the household head. White, Black and Asian adults include those who report being only one race and are not Hispanic. Hispanics are of any race. Prior to 1974, White and Black adults include the Hispanic portion of those groups. Asian adults include Pacific Islanders before 2003.Data on Hispanic adults not available prior to 1974. Data on Asian adults not available before 1988. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1968 to 2020 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p>`,
	"poverty-rate" : `<p>Note: Results are based on income sources in the calendar year prior to the survey, so the impact of the COVID-19 pandemic will not be reflected in the data. Revisions to the Current Population Survey affect the comparison of data from 2015 onwards. White, Black and Asian adults include those who report being only one race and are not Hispanic. Hispanics are of any race. Prior to 1974, White and Black adults include the Hispanic portion of those groups. Asian adults include Pacific Islanders before 2003. Data on Hispanic adults not available prior to 1974. Data on Asian adults not available before 1988. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1969 to 2020 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p>`,
	"median-wealth" : `<p>Note: Wealth is the household’s total assets minus total debts. White and Black adults include those who report being only one race and are not Hispanic. Hispanics are of any race. Data on Asian adults not available. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1983 to 2019 Survey of Consumer Finances.</p>`,
	"life-expectancy" : `<p>Note: White and Black individuals include the Hispanic portion of those groups. Hispanics are of any race. Data on Hispanic adults not available prior to 2006. Data on Asian adults not available. Gaps computed prior to rounding.<br/>
Source: <a href="https://www.cdc.gov/nchs/data/hus/2016/015.pdf" target="_blank">CDC, Life expectancy at birth, by sex, race, and Hispanic origin: United States, selected years 1900–2016.</a></p>`,
"homeownership" : `<p>Note: White, Black, Hispanic, and Asian households refer to the race or ethnicity of the household head. Hispanics are of any race. Asian adults include Pacific Islanders prior to 2003. Data on Asian adults not available before 1988. Gaps computed prior to rounding.<br/>
Source: Pew Research Center analysis of 1976 to 2020 Current Population Survey Annual Social and Economic Supplement (IPUMS).</p>`

  }


;
